(function($) {

	"use strict";

/** --------------------------------------------------
 * 
 *   THEME SCRIPT
 *
 *   TABLE OF CONTENTS
 *   document ready
 *
 *  -------------------------------------------------- */

	var test = function(){

		if($('body').hasClass('node--type-series')) {

			if ($('.paragraph--type-assortment').length > 0) {

				let mq = duo.MediaQuery.getMediaQuery('.paragraph--type-assortment', ':before');

				let isFlickity = false;
				let isFlickityNav = false;

				const $carousel = $('.field--name-field-assortment-items');
				const $mobileTabLinkCollection =  $('.clarysse-custom__assortment-tabs.mobile');

				if(mq === 'true') {
					$carousel.flickity();
					$mobileTabLinkCollection.flickity({
						asNavFor: '.field--name-field-assortment-items',
						contain: true,
						pageDots: false
					});

					isFlickity = true;
					isFlickityNav = true;
				} else {

					if (isFlickity) {
						$carousel.flickity('destroy');
						isFlickity = false;
					}

					if (isFlickityNav) {
						$mobileTabLinkCollection.flickity('destroy');
						isFlickityNav = false;
					}
					
					var $tabLinkCollection =  $('.clarysse-custom__assortment-tabs.desktop a');
					var $sliderItemCollection = $('.paragraph--type-assortment-item');
					var activeClass = 'active';
					var $first = $($tabLinkCollection[0]);
					var $firstAttribute = $first.attr('data-item');

					//remove all active classes first
					$tabLinkCollection.removeClass(activeClass);
					$sliderItemCollection.removeClass(activeClass);
					//add default active class to first items
					$first.addClass(activeClass);
					$(`.${$firstAttribute}`).addClass(activeClass);

					$tabLinkCollection.each(function(){
						var $a = $(this);
						var linkedBlock = $a.attr('data-item');

						$a.on('click', function(e){
							e.preventDefault();
							//remove previous active classes
							$tabLinkCollection.removeClass(activeClass);
							$sliderItemCollection.removeClass(activeClass);
							//add new active classes
							$a.addClass(activeClass);
							$(`.${linkedBlock}`).addClass(activeClass);
						});

					});

				}

			}

		}
	};


/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {		
		test();
	});

	$(window).resize(function() {
		test();
	});
})(jQuery);
